// Vue
import {mixins} from 'vue-class-component'
import {Vue, Component, Prop, Watch, Provide} from 'vue-property-decorator'

// Template
import template from './template.vue'

// Mixins
import {FormInput} from './../../../../mixins/form_input/FormInput'

@Component({
    name: 'CheckboxGroup',
    mixins: [
        template,
    ]
})
export class CheckboxGroup extends mixins(FormInput) {

    @Prop()
    @Provide('checkboxGroupTheme')
    public theme!: string

    @Prop()
    public value?: any[]

    @Prop()
    public name!: string

    @Prop({default: false})
    @Provide('checkboxGroupDisabled')
    public disabled!: boolean

    @Prop({default: () => []})
    public displayErrors!: string[]

    @Prop({default: true})
    public showErrors!: boolean

    @Prop({ default: false })
    public hasFormTourPoint!: boolean

    public isFormTourCurrentStep: boolean = false

    public get themeMap() {
        const themeMap = {
            default: 1,
            secondary: 2
        }

        return themeMap[this.theme] ? themeMap[this.theme] : themeMap['default']
    }

    public get filteredErrors() {
        return this.displayErrors.filter(error => error != '' && error != undefined && error != null )
    }

    public get errorClass() {
        return this.$slots['validation'] || this.filteredErrors.length > 0 ? `${this.$appPrefix}-checkbox-group--error wb-e-check-${this.themeMap}--has-error` : ''
    }

    @Watch('value')
    onValueChange(value: any[], oldValue: any[]) {

        this.broadcast('Checkbox', 'change', [value])
    }

    public created () {
        this.$on('change', this.handleChange)
        this.$on('isFormTourCurrentStep', this.handleIsFormTourCurrentStepChange)
    }

    public destroyed() {
        this.$off('change', this.handleChange)
        this.$off('isFormTourCurrentStep', this.handleIsFormTourCurrentStepChange)
    }


    public handleIsFormTourCurrentStepChange(isFormTourCurrentStep: boolean) {
        this.isFormTourCurrentStep = isFormTourCurrentStep
        this.$emit('update:isTourCurrentStep', isFormTourCurrentStep)
    }

    public mounted () {
        this.broadcast('Checkbox', 'change', [this.value])
    }

    public handleChange(checked: boolean, trueValue: any) {
        let values: any[] = this.value || []

        if (values.includes(trueValue) && !checked) {
            values.splice(values.indexOf(trueValue), 1)
            this.$emit('input', values)
        } else if (!values.includes(trueValue) && checked) {
            values.push(trueValue)
            this.$emit('input', values)
        }
    }

    public selectAll()
    {
        this.broadcast('Checkbox', 'selectAll', [true]);
    }

    public deselectAll()
    {
        this.broadcast('Checkbox', 'selectAll', [false]);
    }

}